module.exports = __webpack_public_path__ + "static/media/solvemoji-pos-logo.3cf5c27f.svg";